<template>
    <div class="page-table haberTanim mainDiv" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.sayfa.guncelleme.pageBaslik")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="sayfaForm" :rules="rulesSayfalar" ref="sayfaForm" class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.baslik")'
                                                      prop="baslik">:
                                            <div v-if="linkVisible" style="float: right; display: flex">
                                                <div v-if="!VisibleA">
                                                    <el-link target="_blank" :underline="false"
                                                             :href="this.path">
                                                        {{this.path}}{{this.sayfaForm.link}}
                                                    </el-link>
                                                </div>
                                                <el-button v-if="duzenleBtnVisible"
                                                           style="margin-left: 10px; margin-bottom: 5px"
                                                           v-on:click="VisibleA = true;  duzenleBtnVisible=false"
                                                           size="mini">Düzenle
                                                </el-button>
                                                <span v-if="VisibleA">{{this.path}} </span>
                                                <el-input v-if="VisibleA" v-model="sayfaForm.link"
                                                          v-on:change="$store.commit('changeTabsClose', false); linkChange = false"
                                                          v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                          style="width: 50%" size="mini"></el-input>
                                            </div>
                                            <el-input
                                                    v-model="sayfaForm.baslik"
                                                    v-on:change="linkTespit(); $store.commit('changeTabsClose', false);"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik")'
                                                      prop="altBaslik">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"
                                                    v-model="sayfaForm.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik")'
                                                      prop="icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v v-model="sayfaForm.icerik"
                                                      @input="seoIcerikTespit(); $store.commit('changeTabsClose', false)"
                                                      @blur="seoIcerikTespit(); $store.commit('changeTabsClose', false)"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <draggable
                                        data-source="juju"
                                        class="list-group"
                                        group="a">
                                    <el-collapse-item title="Resim Ayarları" name="7">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                              prop="resim">:
                                                    <el-upload
                                                            class="resimler"
                                                            action=""
                                                            list-type="picture-card"
                                                            multiple
                                                            :file-list="imageListMain"
                                                            :auto-upload="false"
                                                            accept=".jpg,.jpeg,.png"
                                                            :on-change="imageUpload"
                                                            :on-preview="firstImage"
                                                            :on-remove="imageRemove">
                                                        <i slot="default" class="el-icon-plus"></i>
                                                    </el-upload>
                                                    <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                               v-on:click="serverImageList"
                                                               @click="dialogImgServerVisible = true; " size="mini">
                                                        Sunucudan
                                                        Seç
                                                    </el-button>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item class="card-shadow--medium" title="Belge Ayarları" name="8">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.haberler.tanimlama.belge")'
                                                              prop="belge">:
                                                    <el-row>
                                                        <el-col :lg="12" :md="12" :sm="24" :xs="24">
                                                            <el-upload
                                                                    multiple
                                                                    class="upload-demo"
                                                                    action=""
                                                                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                                                                    :file-list="fileListMain"
                                                                    :auto-upload="false"
                                                                    :on-change="fileUpload"
                                                                    :on-remove="fileRemove">
                                                                <el-button size="mini" style="width: 150px;"
                                                                           type="success">
                                                                    Dosya
                                                                    Yükle
                                                                </el-button>
                                                            </el-upload>
                                                            <el-button style="margin-top: 15px;width: 150px;"
                                                                       type="primary"
                                                                       v-on:click="serverDocumentList"
                                                                       @click="dialogDocServerVisible = true; "
                                                                       size="mini">
                                                                Sunucudan
                                                                Seç
                                                            </el-button>
                                                        </el-col>
                                                    </el-row>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item title="SEO Ayarları" name="9">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                              prop="seoBaslik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              id="seoBaslik"
                                                              @input="seoBaslikChange('seoBaslik')"
                                                              v-model="sayfaForm.seoBaslik"
                                                              :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'>
                                                        <template slot="append">{{seoBaslikLimit}}</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                              prop="seoIcerik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              type="textarea"
                                                              v-on:focus="seoIcerikChange = false"
                                                              v-model="sayfaForm.seoIcerik"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                </draggable>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane v-if="$store.state.dilDurum">
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.baslik")'
                                                      prop="dil.en.baslik">:
                                            <el-input
                                                    v-model="sayfaForm.dil.en.baslik"
                                                    v-on:change="$store.commit('changeTabsClose', false); sayfaForm.dil.en.seoBaslik = sayfaForm.dil.en.baslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.altBaslik")'
                                                      prop="dil.en.altBaslik">:
                                            <el-input
                                                    v-on:change="$store.commit('changeTabsClose', false)"
                                                    v-model="sayfaForm.dil.en.altBaslik"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.icerik")'
                                                      prop="dil.en.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="sayfaForm.dil.en.icerik"
                                                      @input="seoIcerikDilTespit(); $store.commit('changeTabsClose', false)"
                                                      @blur="seoIcerikDilTespit(); $store.commit('changeTabsClose', false)"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse class="animated fadeInUp" style="margin-top: 10px" v-model="activeCollapse">
                                <draggable
                                        data-source="juju"
                                        class="list-group"
                                        group="a">
                                    <el-collapse-item title="Resim Ayarları" name="7">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                              prop="resim">:
                                                    <el-upload
                                                            class="resimler"
                                                            action=""
                                                            list-type="picture-card"
                                                            multiple
                                                            :file-list="imageListMain"
                                                            :auto-upload="false"
                                                            accept=".jpg,.jpeg,.png"
                                                            :on-change="imageUpload"
                                                            :on-preview="firstImage"
                                                            :on-remove="imageRemove">
                                                        <i slot="default" class="el-icon-plus"></i>
                                                    </el-upload>
                                                    <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                               v-on:click="serverImageList"
                                                               @click="dialogImgServerVisible = true; " size="mini">
                                                        Sunucudan
                                                        Seç
                                                    </el-button>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item class="card-shadow--medium" title="Belge Ayarları" name="8">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.haberler.tanimlama.belge")'
                                                              prop="belge">:
                                                    <el-row>
                                                        <el-col :lg="12" :md="12" :sm="24" :xs="24">
                                                            <el-upload
                                                                    multiple
                                                                    class="upload-demo"
                                                                    action=""
                                                                    accept=".pdf,.doc,.docx,.xls,.xlsx"
                                                                    :file-list="fileListMain"
                                                                    :auto-upload="false"
                                                                    :on-change="fileUpload"
                                                                    :on-remove="fileRemove">
                                                                <el-button size="mini" style="width: 150px;"
                                                                           type="success">
                                                                    Dosya
                                                                    Yükle
                                                                </el-button>
                                                            </el-upload>
                                                            <el-button style="margin-top: 15px;width: 150px;"
                                                                       type="primary"
                                                                       v-on:click="serverDocumentList"
                                                                       @click="dialogDocServerVisible = true; "
                                                                       size="mini">
                                                                Sunucudan
                                                                Seç
                                                            </el-button>
                                                        </el-col>
                                                    </el-row>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item title="SEO Ayarları" name="9">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                              prop="dil.en.seoBaslik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              id="seoBaslikDil"
                                                              @input="seoBaslikChange('seoBaslikDil')"
                                                              v-model="sayfaForm.dil.en.seoBaslik"
                                                              :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'>
                                                        <template slot="append">{{seoBaslikDilLimit}}</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                              prop="dil.en.seoIcerik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              type="textarea"
                                                              v-on:focus="seoIcerikIngChange = false"
                                                              v-model="sayfaForm.dil.en.seoIcerik"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                </draggable>
                            </el-collapse>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.sayfa.tanimlama.durum")'>
                            <el-row>
                                <div>
                                    <el-button size="mini" class="onayBtn"
                                               v-on:click="sayfaGuncelle('sayfaForm')"
                                               type="primary">
                                        {{$t('src.views.apps.sayfa.guncelleme.sayfaguncelle')}}
                                    </el-button>
                                </div>
                            </el-row>
                        </el-collapse-item>
                        <draggable class="list-group" group="a">
                            <el-collapse-item :title='$t("src.views.apps.sayfa.tanimlama.sayfatipi")' name="2">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.sayfatipi")'
                                                      prop="sayfaTuru">:
                                            <el-select
                                                    v-model="sayfaForm.sayfaTuru"
                                                    v-on:change="getTreeList"
                                                    style="width: 100%">
                                                <el-option value="0" label="Sayfa">Sayfa</el-option>
                                                <el-option value="1" label="Altsayfa">Altsayfa</el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                v-if="sayfaForm.sayfaTuru === '1'"
                                                :label='$t("src.views.apps.sayfa.tanimlama.sayfaturu")'
                                                prop="sayfaKodu">:
                                            <el-tree
                                                    :data="treeList"
                                                    @node-click="handleNodeClick"
                                                    node-key="id"
                                                    :props="defaultProps">
                                            </el-tree>
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.sayfa.tanimlama.sayfaTuruAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item :title='$t("src.views.apps.sayfa.tanimlama.gorunum")' name="3">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.gorunum")'
                                                      prop="goster">:
                                            <el-switch
                                                    v-on:change="$store.commit('changeTabsClose', false)"
                                                    v-model="sayfaForm.goster"
                                                    active-value="1"
                                                    inactive-value="0"
                                                    active-text="Göster"
                                                    inactive-text="Gösterme">
                                            </el-switch>
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.sayfa.tanimlama.menuAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item :title='$t("src.views.apps.sayfa.tanimlama.resimKonum")' name="4">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="resimKonum">
                                            <el-button type="primary" size="mini" @click="drawerResimKonum = true">
                                                {{this.btnResim}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="sayfaForm.resimKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="60%" height="60%">
                                            <img v-if="sayfaForm.resimKonum === '1'" style="float: right"
                                                 src="../../../assets/images/2.png" width="60%" height="60%">
                                            <img v-if="sayfaForm.resimKonum === '2'" style="float: right"
                                                 src="../../../assets/images/5.png" width="60%" height="60%">
                                            <img v-if="sayfaForm.resimKonum === '3'" style="float: right"
                                                 src="../../../assets/images/4.png" width="60%" height="60%">
                                            <img v-if="sayfaForm.resimKonum === '4'" style="float: right"
                                                 src="../../../assets/images/3.png" width="60%" height="60%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.sayfa.tanimlama.resimKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item :title='$t("src.views.apps.sayfa.tanimlama.menuKonum")' name="5">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="menuKonum">
                                            <el-button type="primary" size="mini" @click="drawerMenuKonum = true">
                                                {{this.btnMenu}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="sayfaForm.menuKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="60%" height="60%">
                                            <img v-if="sayfaForm.menuKonum === '1'" style="float: right"
                                                 src="../../../assets/images/6.png" width="60%" height="60%">
                                            <img v-if="sayfaForm.menuKonum === '2'" style="float: right"
                                                 src="../../../assets/images/9.png" width="60%" height="60%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.sayfa.tanimlama.menuKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item :title='$t("src.views.apps.sayfa.tanimlama.galeriKonum")' name="6">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="galeriKonum">
                                            <el-button type="primary" size="mini" @click="drawerGaleriKonum = true">
                                                {{this.btnGaleri}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="sayfaForm.galeri === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="60%" height="60%">
                                            <img v-if="sayfaForm.galeri === '1'" style="float: right"
                                                 src="../../../assets/images/7.png" width="60%" height="60%">
                                            <img v-if="sayfaForm.galeri === '2'" style="float: right"
                                                 src="../../../assets/images/8.png" width="60%" height="60%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.sayfa.tanimlama.galeriKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
            </el-form>
            <el-dialog
                    title='Sunucudan Fotoğraf Seç'
                    :visible.sync="dialogImgServerVisible"
                    width="60%"
                    center>
                <el-upload
                        action="#"
                        accept=".jpg,.jpeg,.png"
                        :on-change="serverImageUpload"
                        list-type="picture-card"
                        :file-list="imageListServer"
                        :auto-upload="false">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                <i class="el-icon-plus"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
            </el-dialog>
            <el-dialog
                    title='Sunucudan Belge Seç'
                    :visible.sync="dialogDocServerVisible"
                    width="50%"
                    center>
                <el-upload
                        action="#"
                        accept=".pdf,.doc,.docx,.xls,.xlsx"
                        class="upload-demo"
                        :on-preview="fileUploadtoServer"
                        :auto-upload="false"
                        :file-list="fileListServer">
                </el-upload>
            </el-dialog>
            <el-dialog
                    title="Resim Konumu"
                    :visible.sync="drawerResimKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.resimKonum" label="0" @change="changeKonum('resim','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.resimKonum" label="1" @change="changeKonum('resim','1')">
                            <img src="../../../assets/images/2.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.resimKonum" label="2" @change="changeKonum('resim','2')">
                            <img src="../../../assets/images/5.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.resimKonum" label="3" @change="changeKonum('resim','3')">
                            <img src="../../../assets/images/4.png" alt="Sol" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.resimKonum" label="4" @change="changeKonum('resim','4')">
                            <img src="../../../assets/images/3.png" alt="Üst" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title="Menü Konumu"
                    :visible.sync="drawerMenuKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.menuKonum" label="0" @change="changeKonum('menu','0')">
                            <img src="../../../assets/images/1.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.menuKonum" label="1" @change="changeKonum('menu','1')">
                            <img src="../../../assets/images/6.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.menuKonum" label="2" @change="changeKonum('menu','2')">
                            <img src="../../../assets/images/9.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title="Galeri Konumu"
                    :visible.sync="drawerGaleriKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.galeri" label="0" @change="changeKonum('galeri','0')">
                            <img src="../../../assets/images/1.png" alt="Dikey,Büyük" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.galeri" label="1" @change="changeKonum('galeri','1')">
                            <img src="../../../assets/images/7.png" alt="Dikey,Büyük" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="sayfaForm.galeri" label="2" @change="changeKonum('galeri','2')">
                            <img src="../../../assets/images/8.png" alt="Yatay,Küçük" width="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';
    import draggable from 'vuedraggable'

    let $ = JQuery;
    import seoService from '../../../WSProvider/SeoService'
    import sayfaService from '../../../WSProvider/SayfaService'
    import controllerService from '../../../WSProvider/ControllerService'
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataEstas = "";
    export default {
        name: "SayfaGuncelle",
        components: {
            draggable,
        },
        data() {
            return {
                seoBaslikLimit: 0,
                seoBaslikDilLimit: 0,
                drawerResimKonum: false,
                drawerMenuKonum: false,
                drawerGaleriKonum: false,
                path: sayfaService.path,
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                imageListServer: [],
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                linkVisible: false,
                //Tree
                visibleUstSayfa: false,
                treeList: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                // Form
                btnResim: "Seç",
                btnMenu: "Seç",
                btnGaleri: "Seç",
                linkChange: true,
                seoIcerikChange: true,
                seoIcerikDilChange: true,
                VisibleA: false,
                duzenleBtnVisible: true,
                imageListMain: [],
                fileListMain: [],
                fileListServer: [],
                updateSayfaKodu: [],
                updateData: [],
                ustSayfaData: {},
                updateDataEN: [],
                updateDataDE: [],
                sayfaDetayListKlon: [],
                sayfaForm: {
                    baslik: "",
                    altBaslik: "",
                    icerik: "",
                    belge: [],
                    resim: [],
                    seoBaslik: '',
                    seoIcerik: '',
                    durum: "1",
                    link: '',
                    sayfaTuru: '0',
                    ustSayfaKodu: '',
                    gorunum: false,
                    resimKonum: "0",
                    menuKonum: "0",
                    galeriKonum: "0",
                    dil: {
                        en: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        },
                        de: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        }
                    }
                },
                rulesSayfalar: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Başlık Seçiniz",
                        trigger: 'blur'
                    }],
                    seoBaslik: [{
                        max: 70,
                        message: "Tavsiye edilen SEO Başlık limitini aştınız.",
                        trigger: 'change'
                    }],
                    seoIcerik: [{
                        max: 140,
                        message: "Tavsiye edilen SEO İçerik limitini aştınız.",
                        trigger: 'change'
                    }],
                    dil: {
                        en: {
                            seoIcerik: [{
                                max: 140,
                                message: "Tavsiye edilen SEO İçerik limitini aştınız.",
                                trigger: 'change'
                            }]
                        }
                    },
                    dil: {
                        en: {
                            seoBaslik: [{
                                max: 70,
                                message: "Tavsiye edilen SEO Başlık limitini aştınız.",
                                trigger: 'change'
                            }]
                        }
                    }
                },
            }
        },
        mounted() {
            this.updateSayfaKodu = this.$store.state.updateKodu;
            this.getSayfaDetay(this.updateSayfaKodu);
        },
        methods: {
            seoBaslikChange(id) {
                this.seoBaslikLimit = this.sayfaForm.seoBaslik.length;
                this.seoBaslikDilLimit = this.sayfaForm.dil.en.seoBaslik.length;
                if (this.seoBaslikLimit > 70) {
                    $('#' + id).closest('div').find('div').addClass('limitAsim');
                } else {
                    $('#' + id).closest('div').find('div').removeClass('limitAsim');
                }
                if (this.seoBaslikDilLimit > 70) {
                    $('#' + id).closest('div').find('div').addClass('limitAsim');
                } else {
                    $('#' + id).closest('div').find('div').removeClass('limitAsim');
                }
            },
            seoIcerikTespit() {
                if (this.seoIcerikChange) {
                    const myStr = strip_html_tags(this.sayfaForm.icerik);
                    this.sayfaForm.seoIcerik = myStr.substring(0, 140);
                }
            },
            seoIcerikDilTespit() {
                if (this.seoIcerikIngChange) {
                    const myStr = strip_html_tags(this.sayfaForm.dil.en.icerik);
                    this.sayfaForm.dil.en.seoIcerik = myStr.substring(0, 140);
                }
            },
            getSayfaDetay(sayfaKodu) {
                let self = this;
                sayfaService.sayfaDetay(sayfaKodu).then((response) => {
                    if (response.status === 200) {
                        self.linkVisible = true;
                        if (response.data.anaResim) {
                            self.imageListMain.push({
                                name: response.data.anaResim,
                                url: sayfaService.imageUrlOrta + response.data.anaResim
                            });
                        }
                        if (response.data['resim']) {
                            response.data['resim'].forEach(function (e) {
                                if (e) {
                                    self.imageListMain.push({
                                        name: e,
                                        url: sayfaService.imageUrlOrta + e
                                    });
                                }
                            });
                        }
                        if (response.data['belge']) {
                            response.data['belge'].forEach(function (e) {
                                if (e) {
                                    self.fileListMain.push({
                                        name: e,
                                        url: sayfaService.imageUrlOrta + e
                                    });
                                }
                            });
                        }
                        if (response.data['ustSayfaKodu']) {
                            this.sayfaForm.sayfaTuru = '1';
                            this.getTreeList('1')
                        } else {
                            this.sayfaForm.sayfaTuru = '0';
                        }
                        this.sayfaForm.baslik = response.data.baslik;
                        this.sayfaForm.altBaslik = response.data.altBaslik;
                        if (response.data.link) {
                            this.sayfaForm.link = response.data.link;
                            this.linkVisible = true
                        }
                        if (response.data.icerik) {
                            this.sayfaForm.icerik = htmlDecode(response.data.icerik);
                        }
                        this.sayfaForm.seoBaslik = response.data.seoBaslik;
                        this.sayfaForm.seoIcerik = response.data.seoIcerik;
                        this.sayfaForm.durum = response.data.durum;
                        this.sayfaForm.goster = response.data.goster;
                        this.sayfaForm.resimKonum = response.data.resimKonum;
                        this.sayfaForm.menuKonum = response.data.menuKonum;
                        this.sayfaForm.galeri = response.data.galeri;
                        if (this.$store.state.dilDurum) {
                            this.sayfaForm.dil.en.baslik = response.data.dil.en.baslik;
                            this.sayfaForm.dil.en.altBaslik = response.data.dil.en.altBaslik;
                            this.sayfaForm.dil.en.seoBaslik = response.data.dil.en.seoBaslik;
                            this.sayfaForm.dil.en.seoIcerik = response.data.dil.en.seoIcerik;
                            if (response.data.dil.en.icerik) {
                                this.sayfaForm.dil.en.icerik = htmlDecode(response.data.dil.en.icerik);
                            }
                        }
                        this.sayfaDetayListKlon = response.data;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            handleNodeClick(data) {
                this.ustSayfaData = {
                    type: "ustSayfaKodu",
                    value: data.id
                };
            },
            linkTespitLink() {
                let self = this;
                if (this.sayfaForm.link) {
                    seoService.linkKontrol(self.sayfaForm.link.replace("'", "").substring(0, 60)).then((response) => {
                        if (response.status === 200) {
                            self.sayfaForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.linkChange) {
                    seoService.linkKontrol(self.sayfaForm.baslik.replace("'", "").substring(0, 60)).then((response) => {
                        if (self.sayfaForm.baslik) {
                            self.sayfaForm.seoBaslik = self.sayfaForm.baslik.substring(0, 60);
                            if (response.status === 200) {
                                self.linkVisible = true;
                                self.sayfaForm.link = response.data;
                            }
                        } else if (!self.sayfaForm.baslik) {
                            self.linkVisible = false;
                            self.sayfaForm.link = '';
                            self.sayfaForm.seoBaslik = '';
                        }
                    })
                }
            },
            getTreeList(value) {
                if (value === '1') {
                    let self = this;
                    sayfaService.sayfaTree().then((response) => {
                        this.treeList = response.data;
                        self.visibleUstSayfa = true;
                    });
                } else {
                    self.visibleUstSayfa = false;
                }
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageList() {
                var dizi = [];
                controllerService.sunucuResim('sayfa').then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: sayfaService.imageUrlKucuk + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, randomText(7) + '-' + file.name);
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            imageUploadtoServer(file) {
                if (this.imageListMain.length === 0) {
                    var item = {
                        name: file.name.slice(file.name.indexOf("-") + 1),
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    updateList(this, 'resim', 1, file.name.slice(file.name.indexOf("-") + 1));
                    notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                } else {
                    let obj = this.imageListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                    if (obj === undefined) {
                        item = {
                            name: file.name.slice(file.name.indexOf("-") + 1),
                            url: file.url,
                        };
                        this.imageListMain.push(item);
                        updateList(this, 'resim', 1, file.name.slice(file.name.indexOf("-") + 1));
                        notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
                updateList(this, 'resim', 0, file.name);
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('sayfa', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.sayfaForm.resimKonum = "1";
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.sayfaForm.baslik) {
                        var imgname = randomText(7) + '-' + this.sayfaForm.link + ".png";
                    } else {
                        imgname = randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                    }
                    if (this.imageListMain.length === 0) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.imageListMain.push(item);
                        this.sumResimFonk(file, imgname);
                        updateList(this, 'resim', 1, imgname);
                    } else {
                        let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                        if (obj === undefined) {
                            item = {
                                name: imgname,
                                url: file.url,
                                id: file.raw.lastModified
                            };
                            this.imageListMain.push(item);
                            this.sumResimFonk(file, imgname);
                            updateList(this, 'resim', 1, imgname);
                        } else {
                            notification.Status('warning', this, 'Bu resim zaten mevcut');
                        }
                    }
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            serverDocumentList() {
                var dizi = [];
                controllerService.sunucuBelge('sayfa').then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                            };
                            dizi.push(item);
                        });
                        this.fileListServer = dizi;
                    }
                })
            },
            fileUploadtoServer(file) {
                if (this.fileListMain.length === 0) {
                    var item = {
                        name: file.name.slice(file.name.indexOf("-") + 1),
                        url: file.url,
                    };
                    this.fileListMain.push(item);
                    updateList(this, 'belge', 1, file.name.slice(file.name.indexOf("-") + 1));
                    status.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' belgesi eklendi.');
                } else {
                    let obj = this.fileListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                    if (obj === undefined) {
                        item = {
                            name: file.name.slice(file.name.indexOf("-") + 1),
                            url: file.url,
                        };
                        this.fileListMain.push(item);
                        updateList(this, 'belge', 1, file.name.slice(file.name.indexOf("-") + 1));
                        status.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' belgesi eklendi.');
                    } else {
                        status.Status('warning', this, 'Bu belge zaten mevcut');
                    }
                }
            },
            fileRemove(file) {
                this.fileListMain.splice(this.fileListMain.indexOf(file), 1);
                updateList(this, 'belge', 0, file.name);
            },
            fileUpload(file, fileList) {
                let self = this;
                var type = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
                var typeExcel = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                if (file.raw["type"] === type || file.raw["type"] === typeExcel || file.raw["type"] === 'application/vnd.ms-excel' || file.raw["type"] === 'application/msword' || file.raw["type"] === 'application/pdf') {
                    var uzanti = (file.name.slice(file.name.lastIndexOf(".")));
                    var dosyaName = (file.name.split(file.name.slice(file.name.lastIndexOf(".")))[0]).substring(0, 60);
                    var imgname = randomText(7) + '-' + linkTemizle(dosyaName) + uzanti;
                    var item = {
                        name: imgname,
                        url: file.url,
                        id: file.raw.lastModified
                    };
                    this.fileListMain.push(item);
                    const files = file.raw;
                    if (files) {
                        const reader = new FileReader();
                        reader.onload = e => {
                            const data = e.target.result;
                            controllerService.belgeYukle('sayfa', imgname, data).then((response) => {
                                if (response.status === 200) {
                                    self.sayfaForm.belge.push({link:response.data, belgeAdi: imgname});
                                    updateList(this, 'belge', 1, response.data);
                                } else notification.Status(response.status, this);
                            });
                        }
                        reader.readAsDataURL(files);

                    }
                } else {
                    fileList.pop();
                    status.Status('warning', this, 'Yalnızca ".pdf", ".xls", "xlsx", ".doc" ve ".docx" uzantılı görsel seçiniz!!');
                }
            },
            sayfaGuncelle(formName) {
                for (var key in this.sayfaDetayListKlon) {
                    if (key !== 'resim' && key !== 'dil' && key !== 'belge') {
                        if (this.sayfaDetayListKlon[key] !== this.sayfaForm[key]) {
                            if (this.sayfaForm[key]) {
                                var item = {
                                    type: key,
                                    value: this.sayfaForm[key]
                                };
                                this.updateData.push(item);
                            }
                        }
                    } else if (key === 'dil') {
                        for (var keyDil in this.sayfaDetayListKlon.dil.en) {
                            if (this.sayfaDetayListKlon.dil.en[keyDil] !== this.sayfaForm.dil.en[keyDil]) {
                                if (this.sayfaForm.dil.en[keyDil]) {
                                    var itemEn = {
                                        type: keyDil,
                                        value: this.sayfaForm.dil.en[keyDil]
                                    };
                                    this.updateDataEN.push(itemEn);
                                }
                            }
                        }
                        if (this.updateDataEN.length !== 0) {
                            this.updateData.push({
                                type: "dil",
                                value: {
                                    en: this.updateDataEN,
                                }
                            })
                        }
                    }
                }
                if (!_.isEmpty(this.ustSayfaData)) {
                    this.updateData.push(this.ustSayfaData)
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (valid && this.updateData.length !== 0) {
                            sayfaService.sayfaGuncelle(this.updateSayfaKodu, this.updateData).then((response) => {
                                if (response.status === 200) {
                                    notification.Status('success', this, 'Sayfa başarıyla guncellendi.');
                                    this.resetForm(formName);
                                } else if (response.status === 230) {
                                    notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir sayfa zaten mevcut');
                                } else {
                                    notification.Status(response.status, this);
                                }
                            })
                        } else
                            notification.Status('warning', this, 'Değişiklik yapılmadı!');
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.visibleSil = false;
                this.imageListMain = [];
                this.fileListMain = [];
                this.sayfaForm.sayfaTuru = '0';
                this.visibleUstSayfa = false;
                this.sayfaForm.link = null;
                this.linkVisible = false;
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "SayfaGuncelle");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "SayfaGuncelle") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
            changeKonum(item, konum) {
                if (item === 'resim') {
                    this.drawerResimKonum = false;
                    this.btnResim = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Resim konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Resim konumu "Sağ" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Resim konumu "Alt" olarak seçildi.');
                            break;
                        case '3' :
                            notification.Status('success', this, 'Resim konumu "Sol" olarak seçildi.');
                            break;
                        case '4' :
                            notification.Status('success', this, 'Resim konumu "Üst" olarak seçildi.');
                            break;
                    }
                } else if (item === 'menu') {
                    this.drawerMenuKonum = false;
                    this.btnMenu = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Menü konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Menü konumu "Sağ" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Menü konumu "Alt" olarak seçildi.');
                            break;
                    }
                } else if (item === 'galeri') {
                    this.drawerGaleriKonum = false;
                    this.btnGaleri = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Galeri konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Galeri konumu "Dikey,Büyük" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Galeri konumu "Yatay,Küçük" olarak seçildi.');
                            break;
                    }
                }
            }
        },
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")
            .toLowerCase();

    }

    function htmlDecode(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }

    function strip_html_tags(str) {
        str = str.replace(/&nbsp;/gi, '');
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();
        return str.replace(/<[^>]*>/g, '');
    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }

    function updateList(self, type, durum, name) {
        var item = {
            type: type,
            value: [{
                durum: durum,
                [type]: name
            }]
        };
        self.updateData.push(item);
    }
</script>

<style scoped>

</style>